import {
  filterViewFields,
  transformForSubmit,
} from 'platform/forms-system/src/js/helpers';
import { rehydrateFieldSelections } from 'platform/shared/health-apps';
import camelCaseObjectKeys from 'platform/utilities/data/camelCaseObjectKeys';
import omit from 'platform/utilities/data/omit';
import {
  hasPrimaryCaregiver,
  hasSecondaryCaregiverOne,
  hasSecondaryCaregiverTwo,
} from '../utils/helpers';

const CHAPTER_NAME_BY_PREFIX = {
  veteran: 'veteran',
  primary: 'primaryCaregiver',
  secondaryOne: 'secondaryCaregiverOne',
  secondaryTwo: 'secondaryCaregiverTwo',
};

const IS_PARTY_INCLUDED_BY_PREFIX = {
  veteran: () => true,
  primary: hasPrimaryCaregiver,
  secondaryOne: hasSecondaryCaregiverOne,
  secondaryTwo: hasSecondaryCaregiverTwo,
};

const withoutAddressCountry = (key, value) =>
  key.endsWith('Address') ? omit(['country'], value) : value;

const safeFilterViewFields = value =>
  value && typeof value === 'object' ? filterViewFields(value) : value;

const buildChapterSortedObject = (dataPrefix, data, rawData) => {
  const dataKeys = Object.keys(data).filter(key => key.includes(dataPrefix));

  if (!dataKeys.length) return {};

  const sameAsMailingAddress =
    rawData[`view:${dataPrefix}HomeSameAsMailingAddress`];

  const rawByPrefix = dataKeys.reduce((acc, key) => {
    const strippedKey = key.split(dataPrefix)[1];
    const value = withoutAddressCountry(key, data[key]);
    acc[strippedKey] = value;

    if (sameAsMailingAddress && key === `${dataPrefix}Address`) {
      acc.MailingAddress = value;
    }

    return acc;
  }, {});

  return {
    [CHAPTER_NAME_BY_PREFIX[dataPrefix]]: camelCaseObjectKeys(rawByPrefix),
  };
};

const buildRepresentativeData = data => {
  const {
    signAsRepresentativeYesNo: yesNo,
    signAsRepresentativeDocumentUpload: upload,
  } = data;
  const signAsRepresentative = yesNo === 'yes';
  const hasDocumentUpload = Object.keys(upload || {}).length > 0;

  return signAsRepresentative && hasDocumentUpload
    ? { signAsRepresentative, poaAttachmentId: upload.confirmationCode }
    : { signAsRepresentative };
};

const submitTransformer = (formConfig, form) => {
  const rawData = form.data;
  const filteredData = JSON.parse(transformForSubmit(formConfig, form));
  const rehydratedData = rehydrateFieldSelections(
    formConfig,
    rawData,
    filteredData,
    safeFilterViewFields,
  );

  const remappedData = Object.keys(CHAPTER_NAME_BY_PREFIX)
    .filter(prefix => IS_PARTY_INCLUDED_BY_PREFIX[prefix](rawData))
    .map(prefix => buildChapterSortedObject(prefix, rehydratedData, rawData))
    .reduce(
      (acc, chapterData) => ({ ...acc, ...chapterData }),
      buildRepresentativeData(rehydratedData),
    );

  return JSON.stringify({
    caregiversAssistanceClaim: {
      form: JSON.stringify(remappedData),
    },
  });
};

export default submitTransformer;
